import styled from 'styled-components';
import { Box, Button } from '@scope/scope-one-ui/core';
import { COLORS, SIZES } from '@scope/scope-one-ui/theme';

export const StepChoiceWrapper = styled(Box)`
  text-align: center;
  display: flex;
  flex-direction: column;
  width: 100%;
  justify-content: center;
`;

export const AccentedWord = styled.mark`
  color: ${COLORS.typography.label};
  background: none;
`;

export const TemplateArea = styled(Box)`
  color: ${COLORS.success.main};
  display: flex;
  background-color: ${COLORS.success.hover};
  align-items: center;
  justify-content: space-between;
  padding: ${SIZES.spacing(2)};
`;

export const DownloadTemplateButton = styled(Button)`
  background-color: ${COLORS.success.main};
  &:enabled {
    background-color: ${COLORS.success.main};
  }
`;
